import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';
import ModalShell from './ModalShell';

/**
 * YesNoPopup - Confirmation dialog overlay using ModalShell
 * @param {boolean} isOpen - Whether the popup is visible
 * @param {string} title - Popup title
 * @param {string} message - Popup message/description
 * @param {string} confirmLabel - Label for confirm button (default: "Yes")
 * @param {string} cancelLabel - Label for cancel button (default: "No")
 * @param {string} variant - 'danger' | 'default' (default: 'default')
 * @param {boolean} loading - Show spinner on confirm button
 * @param {function} onConfirm - Called when user confirms
 * @param {function} onCancel - Called when user cancels
 */
export default function YesNoPopup({
  isOpen,
  title,
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  variant = 'default',
  loading = false,
  onConfirm,
  onCancel
}) {
  const footer = (
    <>
      <button className="ms-btn ms-btn-ghost" onClick={onCancel} disabled={loading}>
        {cancelLabel}
      </button>
      <button
        className={`ms-btn ${variant === 'danger' ? 'ms-btn-danger' : 'ms-btn-primary'}`}
        onClick={onConfirm}
        disabled={loading}
      >
        {loading ? <FontAwesomeIcon icon={ICONS.SPINNER} spin /> : confirmLabel}
      </button>
    </>
  );

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      title={title}
      footer={footer}
    >
      {message && <p className="ynp-message">{message}</p>}
    </ModalShell>
  );
}
